// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth screens (sign in, forgot password, OTP, accept invitation, select project).
   Built on the shared foundation tokens from ./tokens/tokens.css — see "JoPath · Web Platform" Auth board. */

.auth {
  position: relative;
  display: flex;
  min-height: 100vh;
  background: var(--background);
}

.auth__lang {
  position: fixed;
  top: 1.5rem;
  inset-inline-end: 1.5rem;
  z-index: var(--z-sticky);
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  background: var(--muted);
  border-radius: var(--radius-md);
}

.auth__lang-btn {
  min-width: 32px;
  min-height: 32px;
  padding: 0.25rem 0.6rem;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--muted-foreground);
  font-weight: 600;
  font-size: var(--text-body-sm);
  cursor: pointer;
}

.auth__lang-btn.is-active {
  background: var(--card);
  color: var(--foreground);
  box-shadow: var(--shadow-color-soft) 0 1px 2px;
}

.auth__main {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 3rem 1.5rem;
}

.auth__main:focus {
  outline: none;
}

.auth__card {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: min(400px, 100%);
}

.auth__wordmark {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--primary-text);
  letter-spacing: -0.02em;
}

.auth__head {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.auth__head h1 {
  font-size: var(--text-h2);
}

.auth__head p {
  color: var(--muted-foreground);
}

.auth__head--center {
  align-items: center;
  text-align: center;
}

.auth__options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.auth__options.is-disabled {
  opacity: var(--opacity-disabled);
  pointer-events: none;
}

.auth__footer {
  text-align: center;
  font-size: var(--text-body-sm);
  color: var(--muted-foreground);
}

.auth__back {
  align-self: center;
}

.auth__aside {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--primary);
  color: var(--primary-foreground);
  text-align: center;
}

.auth__aside-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 420px;
}

.auth__aside-mark {
  padding: 0.65rem 1.1rem;
  border: 1px solid var(--tactile-edge-on-primary);
  border-radius: var(--radius-xl);
  font-size: 1.9rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.auth__aside-tagline {
  font-size: var(--text-h3);
  font-weight: 600;
  line-height: 1.5;
}

.auth__icon-badge {
  display: grid;
  place-items: center;
  align-self: center;
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background: var(--primary-subtle);
  color: var(--primary-text);
}

.auth__invite {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem;
  border-radius: var(--radius-lg);
  background: var(--muted);
  font-size: var(--text-body-sm);
}

.auth__invite small {
  color: var(--muted-foreground);
}

/* ---------- OTP ---------- */

fieldset.stack {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

fieldset.stack legend {
  padding: 0;
}

.auth__otp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}

.auth__otp-group {
  display: flex;
  gap: 0.4rem;
}

.auth__otp-sep {
  color: var(--border-strong);
}

.auth__otp-input {
  width: 42px;
  height: 48px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  border: 1px solid var(--input);
  border-radius: var(--radius-md);
  background: var(--card);
  color: var(--foreground);
}

.auth__otp-input:focus {
  border-color: var(--ring);
  outline: 2px solid var(--focus-ring);
  outline-offset: 0;
}

.auth__resend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  font-size: var(--text-body-sm);
  color: var(--muted-foreground);
}

/* ---------- Select project ---------- */

.auth__projects {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.auth__project {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--card);
  color: inherit;
  text-align: start;
  font: inherit;
  cursor: pointer;
}

.auth__project:hover {
  border-color: var(--border-strong);
}

.auth__project.is-selected {
  border: 2px solid var(--primary);
  background: var(--primary-subtle);
  padding: calc(0.75rem - 1px) calc(0.9rem - 1px);
}

.auth__project-avatar {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  background: var(--primary-subtle);
  color: var(--primary-text);
  font-weight: 700;
  font-size: var(--text-body-sm);
}

.auth__project-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.auth__project-body strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.auth__project-meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.auth__project-meta small {
  color: var(--muted-foreground);
  font-size: var(--text-caption);
}

.auth__project-check {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 16px;
  color: var(--primary);
}

/* ---------- Role badge ---------- */

.role-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.6rem;
  border-radius: var(--radius-full);
  background: var(--info-subtle);
  color: var(--info-subtle-foreground);
  font-size: var(--text-caption);
  font-weight: 600;
  white-space: nowrap;
}

@media (max-width: 860px) {
  .auth__aside {
    display: none;
  }

  .auth__main {
    flex: 1 1 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/auth.css"],"names":[],"mappings":"AAAA;6GAC6G;;AAE7G;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gDAAgD;EAChD,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;;AAE9B;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,yCAAyC;;AAEzC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;;AAEA,qCAAqC;;AAErC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Auth screens (sign in, forgot password, OTP, accept invitation, select project).\r\n   Built on the shared foundation tokens from ./tokens/tokens.css — see \"JoPath · Web Platform\" Auth board. */\r\n\r\n.auth {\r\n  position: relative;\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background: var(--background);\r\n}\r\n\r\n.auth__lang {\r\n  position: fixed;\r\n  top: 1.5rem;\r\n  inset-inline-end: 1.5rem;\r\n  z-index: var(--z-sticky);\r\n  display: inline-flex;\r\n  gap: 2px;\r\n  padding: 2px;\r\n  background: var(--muted);\r\n  border-radius: var(--radius-md);\r\n}\r\n\r\n.auth__lang-btn {\r\n  min-width: 32px;\r\n  min-height: 32px;\r\n  padding: 0.25rem 0.6rem;\r\n  border: 0;\r\n  border-radius: var(--radius-sm);\r\n  background: transparent;\r\n  color: var(--muted-foreground);\r\n  font-weight: 600;\r\n  font-size: var(--text-body-sm);\r\n  cursor: pointer;\r\n}\r\n\r\n.auth__lang-btn.is-active {\r\n  background: var(--card);\r\n  color: var(--foreground);\r\n  box-shadow: var(--shadow-color-soft) 0 1px 2px;\r\n}\r\n\r\n.auth__main {\r\n  flex: 1 1 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 0;\r\n  padding: 3rem 1.5rem;\r\n}\r\n\r\n.auth__main:focus {\r\n  outline: none;\r\n}\r\n\r\n.auth__card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  width: min(400px, 100%);\r\n}\r\n\r\n.auth__wordmark {\r\n  font-size: 1.75rem;\r\n  font-weight: 700;\r\n  color: var(--primary-text);\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.auth__head {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.auth__head h1 {\r\n  font-size: var(--text-h2);\r\n}\r\n\r\n.auth__head p {\r\n  color: var(--muted-foreground);\r\n}\r\n\r\n.auth__head--center {\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.auth__options {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.auth__options.is-disabled {\r\n  opacity: var(--opacity-disabled);\r\n  pointer-events: none;\r\n}\r\n\r\n.auth__footer {\r\n  text-align: center;\r\n  font-size: var(--text-body-sm);\r\n  color: var(--muted-foreground);\r\n}\r\n\r\n.auth__back {\r\n  align-self: center;\r\n}\r\n\r\n.auth__aside {\r\n  flex: 1 1 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n  background: var(--primary);\r\n  color: var(--primary-foreground);\r\n  text-align: center;\r\n}\r\n\r\n.auth__aside-inner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n  max-width: 420px;\r\n}\r\n\r\n.auth__aside-mark {\r\n  padding: 0.65rem 1.1rem;\r\n  border: 1px solid var(--tactile-edge-on-primary);\r\n  border-radius: var(--radius-xl);\r\n  font-size: 1.9rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.auth__aside-tagline {\r\n  font-size: var(--text-h3);\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n}\r\n\r\n.auth__icon-badge {\r\n  display: grid;\r\n  place-items: center;\r\n  align-self: center;\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: var(--radius-full);\r\n  background: var(--primary-subtle);\r\n  color: var(--primary-text);\r\n}\r\n\r\n.auth__invite {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  padding: 1rem;\r\n  border-radius: var(--radius-lg);\r\n  background: var(--muted);\r\n  font-size: var(--text-body-sm);\r\n}\r\n\r\n.auth__invite small {\r\n  color: var(--muted-foreground);\r\n}\r\n\r\n/* ---------- OTP ---------- */\r\n\r\nfieldset.stack {\r\n  border: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  min-width: 0;\r\n}\r\n\r\nfieldset.stack legend {\r\n  padding: 0;\r\n}\r\n\r\n.auth__otp {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.auth__otp-group {\r\n  display: flex;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.auth__otp-sep {\r\n  color: var(--border-strong);\r\n}\r\n\r\n.auth__otp-input {\r\n  width: 42px;\r\n  height: 48px;\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  border: 1px solid var(--input);\r\n  border-radius: var(--radius-md);\r\n  background: var(--card);\r\n  color: var(--foreground);\r\n}\r\n\r\n.auth__otp-input:focus {\r\n  border-color: var(--ring);\r\n  outline: 2px solid var(--focus-ring);\r\n  outline-offset: 0;\r\n}\r\n\r\n.auth__resend {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  font-size: var(--text-body-sm);\r\n  color: var(--muted-foreground);\r\n}\r\n\r\n/* ---------- Select project ---------- */\r\n\r\n.auth__projects {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.6rem;\r\n}\r\n\r\n.auth__project {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n  padding: 0.75rem 0.9rem;\r\n  border: 1px solid var(--border);\r\n  border-radius: var(--radius-lg);\r\n  background: var(--card);\r\n  color: inherit;\r\n  text-align: start;\r\n  font: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.auth__project:hover {\r\n  border-color: var(--border-strong);\r\n}\r\n\r\n.auth__project.is-selected {\r\n  border: 2px solid var(--primary);\r\n  background: var(--primary-subtle);\r\n  padding: calc(0.75rem - 1px) calc(0.9rem - 1px);\r\n}\r\n\r\n.auth__project-avatar {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: var(--radius-full);\r\n  background: var(--primary-subtle);\r\n  color: var(--primary-text);\r\n  font-weight: 700;\r\n  font-size: var(--text-body-sm);\r\n}\r\n\r\n.auth__project-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.auth__project-body strong {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.auth__project-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.auth__project-meta small {\r\n  color: var(--muted-foreground);\r\n  font-size: var(--text-caption);\r\n}\r\n\r\n.auth__project-check {\r\n  display: grid;\r\n  place-items: center;\r\n  flex-shrink: 0;\r\n  width: 16px;\r\n  color: var(--primary);\r\n}\r\n\r\n/* ---------- Role badge ---------- */\r\n\r\n.role-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  padding: 0.1rem 0.6rem;\r\n  border-radius: var(--radius-full);\r\n  background: var(--info-subtle);\r\n  color: var(--info-subtle-foreground);\r\n  font-size: var(--text-caption);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .auth__aside {\r\n    display: none;\r\n  }\r\n\r\n  .auth__main {\r\n    flex: 1 1 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
